
import { Component, Prop, Vue } from 'vue-property-decorator'
import ImageBase from '@/components/atoms/ImageBase.vue'
import ButtonBase from '@/components/atoms/ButtonBase.vue'
import PanelFrame from '@/components/molecules/PanelFrame.vue'
import ButtonOptional from '@/components/molecules/ButtonOptional.vue'
import { AvatarCode } from '@/const/AvatarCode'
import DateUtils from '@/utils/DateUtils'

/**
 * トップページの生徒情報パネル
 */
@Component({
  components: {
    PanelFrame,
    ImageBase,
    ButtonBase,
    ButtonOptional,
  },
})
export default class StudentPanel extends Vue {
  /** コインボタン押下時のイベント */
  @Prop()
  private eventClickCoinButton!: () => void

  /** 履歴ボタン押下時のイベント */
  @Prop()
  private eventClickHistoryButton!: () => void

  /** 生徒情報 */
  private student = this.$appCookies.authStudent.get()

  /**
   * 塾名(校名)
   *
   * @returns cookie保持している塾名+教室名
   */
  private get schoolName(): string {
    return `${this.student.academyName} ${this.student.branchName}`
  }

  /**
   * 生徒ニックネーム
   *
   * @returns cookie保持している生徒ニックネーム
   */
  private get studentNickName(): string {
    return this.student.nickname
  }

  /**
   * 生徒ID
   *
   * @returns cookie保持している生徒ID
   */
  private get studentId(): string {
    return this.student.loginId
  }

  /**
   * アイコン画像URL
   *
   * @returns cookie保持している画像URL
   */
  private get studentImageUrl(): string {
    // TODO 画像配置がs3だった場合、処理追加
    const icon = AvatarCode.findByCode(this.student.avatarIconCode)
    return icon.path
  }

  /**
   * 前回ログイン日
   *
   * @returns cookie保持している前回ログイン日
   */
  private get lastLoginDate(): string {
    if (!this.student.lastLoginDate) {
      return '----/--/--'
    }
    const date = new Date(this.student.lastLoginDate * 1000)
    return DateUtils.format(date, false)
  }
}
